import React from "react";

export const LoginICBINT = () => {
  return <h1>Not Implemented</h1>;
};
